// Caching the needed Dom Elements
const currentYearElements = window.document.querySelectorAll('.current-year');
const currentYear = new Date().getFullYear();

// auto update Current year functionality
export const autoUpdateCurrentYear = () => {
  currentYearElements.forEach((ele) => {
    ele.textContent = currentYear;
  });
};
